<template>
  <Input
      ref="input"
      v-model="search.value"
      :placeholder="'请输入' + search.label"
      :number="search.type==='number'"
      :maxlength="search.max"
      @on-change="handleChange"
      @on-enter="emitSearchQuery"
  >
  </Input>
</template>

<script>
export default {
  props: {
    search: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  created () {
    // this.search.value = this.search.value || '';
  },
  watch: {
  },
  computed: {
  },
  methods: {
    handleChange () {
      const _self = this;
      if (_self.search.type === 'number' && isNaN(Number(_self.search.value))) {
        // 如果规定为数字类型，不能输入非数字内容
        _self.$nextTick(function () {
          _self.search.value = _self.search.value.length === 1 ? '' : _self.search.value.substr(0, _self.search.value.length - 1);
          _self.search.value = (_self.search.value + '').trim();
          _self.$emit('getSearchValueChange', _self.search);
        });
      } else {
        _self.search.value = (_self.search.value + '').trim();
        _self.$emit('getSearchValueChange', _self.search);
      }
    },
    emitSearchQuery () {
      const _self = this;
      _self.contentFlag = false;
      // 将值往上传
      _self.$emit('enter');
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/regularQuery/input.vue